import { isBefore } from "date-fns";

export function sortByDateComparator<T>(
    getValue: (n: T | undefined) => Date | undefined,
    showUndefinedAsLastInDecendingOrder = false,
) {
    return (a: T | undefined, b: T | undefined) => {
        const valueA = getValue(a);
        const valueB = getValue(b);

        if (valueA && !valueB) {
            return showUndefinedAsLastInDecendingOrder ? 1 : -1;
        }
        if (!valueA && valueB) {
            return showUndefinedAsLastInDecendingOrder ? -1 : 1;
        }

        if (valueA && valueB) {
            return isBefore(valueA, valueB) ? -1 : 1;
        }

        return 0;
    };
}
